import PropTypes from "prop-types"
import React from "react"

import { connect } from "react-redux"
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu"

import { withTranslation } from "react-i18next"

import {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
} from "../../store/actions"

const TOP_ROW_IMAGES = [1, 2, 3, 4, 5]
const BOTTOM_ROW_IMAGES = [6, 7, 8, 9, 10]

const HeaderImageStrip = ({ ids }) => (
  <div className="app-header-strip">
    {ids.map(id => (
      <img
        key={id}
        src={`/header/${id}.webp`}
        alt=""
        className="app-header-strip-img"
      />
    ))}
  </div>
)

HeaderImageStrip.propTypes = {
  ids: PropTypes.array.isRequired,
}

const Header = () => {
  function tToggle() {
    var body = document.body
    if (window.screen.width <= 998) {
      body.classList.toggle("sidebar-enable")
    } else {
      body.classList.toggle("vertical-collpsed")
      body.classList.toggle("sidebar-enable")
    }
  }

  return (
    <React.Fragment>
      <header id="page-topbar" className="app-topbar">
        {/* Desktop topbar - only visible on screen width >= 992px */}
        <div className="app-topbar-desktop">
          <div className="app-topbar-row app-topbar-row-top">
            <HeaderImageStrip ids={TOP_ROW_IMAGES} />
            <div className="app-topbar-right">
              <ProfileMenu />
            </div>
          </div>
          <div className="app-topbar-row app-topbar-row-bottom">
            <HeaderImageStrip ids={BOTTOM_ROW_IMAGES} />
            <div className="app-topbar-right">
              <img
                src="/header/coldblock-logo.webp"
                alt="ColdBlock"
                className="app-topbar-logo"
              />
            </div>
          </div>
        </div>

        {/* Mobile topbar - only visible on screen width < 992px */}
        <div className="app-topbar-mobile">
          <div className="app-topbar-mobile-left">
            <button
              type="button"
              onClick={tToggle}
              className="btn btn-sm px-2 font-size-18 text-dark"
              id="vertical-menu-btn-mobile"
            >
              <i className="fa fa-fw fa-bars" />
            </button>
            <img
              src="/header/coldblock-logo.webp"
              alt="ColdBlock"
              className="app-topbar-mobile-logo"
            />
          </div>
          <div className="app-topbar-mobile-right">
            <ProfileMenu />
          </div>
        </div>
      </header>
    </React.Fragment>
  )
}

Header.propTypes = {
  changeSidebarType: PropTypes.func,
  leftMenu: PropTypes.any,
  leftSideBarType: PropTypes.any,
  showRightSidebar: PropTypes.any,
  showRightSidebarAction: PropTypes.func,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func,
}

const mapStatetoProps = state => {
  const { layoutType, showRightSidebar, leftMenu, leftSideBarType } =
    state.Layout
  return { layoutType, showRightSidebar, leftMenu, leftSideBarType }
}

export default connect(mapStatetoProps, {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
})(withTranslation()(Header))
